/**
 * date-fns locale 映射（OPT-005：日期显示跟随界面语言）
 * i18n 语言码 → date-fns Locale；未知语言回退 zhTW（与默认语言一致）
 */

import { enUS, ja, ko, de, zhTW } from 'date-fns/locale'
import type { Locale } from 'date-fns'

const MAP: Record<string, Locale> = {
  en: enUS,
  ja,
  ko,
  de,
  'zh-TW': zhTW,
}

export function dateLocale(lang: string): Locale {
  return MAP[lang] ?? zhTW
}
